<template>
  <v-row no-gutters class="d-flex align-stretch register-page">
    <v-col cols="12" md="3" class="d-none d-md-flex">
      <v-img :src="imgUrl('register-bg.jpg')" height="100%"></v-img>
    </v-col>
    <v-col cols="12" md="9">
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" sm="12" md="10">
          <h2 class="title-register py-8">
            <translate>Become a Member</translate>
          </h2>
          <v-stepper v-model="step" vertical>
            <v-stepper-step :complete="step > 1" step="1"
              ><translate>Create Account</translate></v-stepper-step
            >
            <v-stepper-content
              step="1"
              :class="isInfomation ? 'displayNone' : 'displayBlock'"
            >
              <FormRegistMember />
            </v-stepper-content>
            <v-stepper-content
              step="2"
              class="infomationMemberCard no-transition"
              :class="isInfomation ? 'displayBlock' : 'displayNone'"
            >
              <span class="editIcon" @click="editInformation"
                ><v-icon class="fas fa-pen pr-2" size="15"></v-icon>
                <translate>Edit</translate></span
              >
              <v-card class="mb-12 no-transition">
                <v-row no-gutters class="pb-4 no-transition">
                  <v-col cols="5" :md="3" class="title">
                    <translate>Email</translate>
                  </v-col>
                  <v-col cols="7" :md="9" class="content">
                    {{ formRegistMember.email || "" }}
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="5" :md="3" class="title">
                    <translate>Password</translate>
                  </v-col>
                  <v-col cols="7" :md="9" class="content"> ********** </v-col>
                </v-row>
              </v-card>
            </v-stepper-content>
            <v-stepper-content
              step="2"
              class="editForm no-transition"
              :class="isInfomation ? 'displayNone' : 'displayBlock'"
            >
              <FormRegistMember />
            </v-stepper-content>
            <v-stepper-step :complete="step > 2" step="2">
              <translate>Information</translate>
            </v-stepper-step>

            <v-stepper-content step="2">
              <InfomationForm />
            </v-stepper-content>
          </v-stepper>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import FormRegistMember from "@/components/Forms/FormRegistMember";
import InfomationForm from "@/components/Forms/InformationForm";
export default {
  name: "StepRegistMember",
  data() {
    return {
      // step: 1,
    };
  },
  components: { FormRegistMember, InfomationForm },
  computed: {
    ...mapState("stepper", {
      step: (state) => state.step,
      isInfomation: (state) => state.isInfomation,
      formRegistMember: (state) => state.formRegistMember,
    }),
  },
  methods: {
    editInformation() {
      this.$store.commit("stepper/editInformation");
    },
  },
};
</script>
<style lang="scss">
.register-page .AppFooter {
  margin-top: 0 !important;
}
</style>